import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { RoutesHistoricService } from 'src/app/services/routes-services/routes-historic-service/routes-historic.service';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';

declare const window: any;

@Component({
  selector: 'app-turns-new-desk-creation-card',
  templateUrl: './turns-new-desk-creation-card.component.html',
  styleUrls: ['./turns-new-desk-creation-card.component.scss']
})
export class TurnsNewDeskCreationCardComponent implements OnInit, OnDestroy {

  @Input() deskTypes;
  @Input() smsList;
  ticketList;
  @Input() centerList;
  imageUrl: string;
  rememberedSchedules;
  rememberDeskInfoFromSheduleListenSubscription: Subscription;
  addNewDeskSubscription: Subscription;
  addNewDeskScheduleSubscription: Subscription;
  getSmsListSubscription: Subscription;
  getTicketListByCentersSubscription: Subscription;
  validationImageToBase64Subscription: Subscription;
  showButton: boolean;
  basicDataForm = new FormGroup({
    name: new FormControl(null, Validators.required),
    active: new FormControl(true),
    selectedCenter: new FormControl(null, Validators.required),
    selectedDeskType: new FormControl(null, Validators.required),
    voiceActivate: new FormControl(false),
    voicePrefix: new FormControl(null),
    deskPrefix: new FormControl(null),
    canAskCustomerName: new FormControl(false),
    dailyReset: new FormControl(true),
    smsNotify: new FormControl(false),
    selectedSMS: new FormControl(null),
    notifyPrevious: new FormControl(true),
    notifyLast: new FormControl(true),
    canPrint: new FormControl(false),
    selectedTicket: new FormControl(null),
    countAutoReset: new FormControl(false),
    initialCount: new FormControl('1'),
    limitCount: new FormControl('100'),
    showTurnsAtTotem: new FormControl(false),
    availableTurn: new FormControl(false),
    autoAdvance: new FormControl(true),
    dataType: new FormControl(null),
    hasVip: new FormControl(false)
  });

  constructor(private desksTurnsService: DesksTurnsService,
    private userStorageService: UserStorageService,
    private snackbarService: SnackBarService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private spinnerService: SpinnerService,
    private ticketsService: TicketsService,
    private routesHistoricService: RoutesHistoricService,
    public dialog: MatDialog) {
    this.showButton = true;
  }

  ngOnInit() {
    this.rememberedSchedules = this.desksTurnsService.getRememberedSchedules();
    const rememberedInfo = this.desksTurnsService.getRememberedDeskInfo();
    if (this.routesHistoricService.getPreviousUrl() !== '/turns/desk/schedule') {
      this.desksTurnsService.deleteAllRememberedSchedule();
    } else {
      if (rememberedInfo['rememberedDeskImage']) { this.imageUrl = rememberedInfo['rememberedDeskImage']; }
      if (rememberedInfo['rememberedDeskForm']) { this.basicDataForm = rememberedInfo['rememberedDeskForm']; }
    }
  }

  public addNewDesk() {
    this.showButton = false;
    this.spinnerService.show('desk-new-spinner');
    const validation = this.validateForm();
    if (validation === true) {
      const active = this.basicDataForm.get('active').value;
      const name = this.basicDataForm.get('name').value;
      const selectedCenter = this.getSelectedCenter();
      const selectedDeskType = this.getSelectedDeskType();
      const autoAdvance = this.basicDataForm.get('autoAdvance').value;
      let voiceActivate = this.basicDataForm.get('voiceActivate').value;
      let voicePrefix = this.basicDataForm.get('voicePrefix').value;
      let deskPrefix = this.basicDataForm.get('deskPrefix').value;
      let canAskCustomerName = this.basicDataForm.get('canAskCustomerName').value;
      let dailyReset = this.basicDataForm.get('dailyReset').value;
      let smsNotify = this.basicDataForm.get('smsNotify').value;
      let selectedSms = this.getSelectedSMS();
      let notifyPrevious = this.basicDataForm.get('notifyPrevious').value;
      let notifyLast = this.basicDataForm.get('notifyLast').value;
      let canPrint = this.basicDataForm.get('canPrint').value;
      let selectedTicket = this.getSelectedTicket();
      let countAutoReset = this.basicDataForm.get('notifyPrevious').value;
      let initialCount = this.basicDataForm.get('initialCount').value;
      let limitCount = this.basicDataForm.get('limitCount').value;
      let showTurnsAtTotem = this.basicDataForm.get('showTurnsAtTotem').value;
      let availableTurn = this.basicDataForm.get('availableTurn').value;
      let dataType = null;
      const hasVip = this.basicDataForm.get('hasVip').value;
      switch (this.basicDataForm.get('selectedDeskType').value.InternalId) {
        // NORMAL
        case 'MSHMV1BJ9THXZL9CIYPT25T6R7427OY42':
          voiceActivate = this.basicDataForm.get('voiceActivate').value;
          voicePrefix = this.basicDataForm.get('voicePrefix').value;
          deskPrefix = this.basicDataForm.get('deskPrefix').value;
          canAskCustomerName = this.basicDataForm.get('canAskCustomerName').value;
          dailyReset = this.basicDataForm.get('dailyReset').value;
          smsNotify = this.basicDataForm.get('smsNotify').value;
          selectedSms = this.getSelectedSMS();
          notifyPrevious = this.basicDataForm.get('notifyPrevious').value;
          notifyLast = this.basicDataForm.get('notifyLast').value;
          canPrint = this.basicDataForm.get('canPrint').value;
          selectedTicket = this.getSelectedTicket();
          countAutoReset = this.basicDataForm.get('countAutoReset').value;
          initialCount = this.basicDataForm.get('initialCount').value;
          limitCount = this.basicDataForm.get('limitCount').value;
          showTurnsAtTotem = this.basicDataForm.get('showTurnsAtTotem').value;
          availableTurn = this.basicDataForm.get('availableTurn').value;
          break;
        // MULTIPLE_ATTENDING
        case 'MSHMV4BJ9THXZL9CIYPT25T6R7427OY42':
          voiceActivate = this.basicDataForm.get('voiceActivate').value;
          voicePrefix = this.basicDataForm.get('voicePrefix').value;
          deskPrefix = this.basicDataForm.get('deskPrefix').value;
          canAskCustomerName = this.basicDataForm.get('canAskCustomerName').value;
          dailyReset = this.basicDataForm.get('dailyReset').value;
          smsNotify = this.basicDataForm.get('smsNotify').value;
          selectedSms = this.getSelectedSMS();
          notifyPrevious = this.basicDataForm.get('notifyPrevious').value;
          notifyLast = this.basicDataForm.get('notifyLast').value;
          canPrint = this.basicDataForm.get('canPrint').value;
          selectedTicket = this.getSelectedTicket();
          countAutoReset = this.basicDataForm.get('countAutoReset').value;
          initialCount = this.basicDataForm.get('initialCount').value;
          limitCount = this.basicDataForm.get('limitCount').value;
          showTurnsAtTotem = this.basicDataForm.get('showTurnsAtTotem').value;
          availableTurn = this.basicDataForm.get('availableTurn').value;
          dataType = this.basicDataForm.get('dataType').value ? dataType = 'NUMERIC' : dataType = 'ALPHANUMERIC';
          break;
        // SINGLE_ROW
        case 'MSHMV2BJ9THXZL9CIYPT25T6R7427OY42':
          voiceActivate = this.basicDataForm.get('voiceActivate').value;
          voicePrefix = this.basicDataForm.get('voicePrefix').value;
          deskPrefix = null;
          canAskCustomerName = null;
          dailyReset = null;
          smsNotify = false;
          selectedSms = null;
          notifyPrevious = false;
          notifyLast = false;
          canPrint = false;
          selectedTicket = null;
          countAutoReset = false;
          initialCount = 0;
          limitCount = 0;
          showTurnsAtTotem = null;
          break;
      }
      this.addNewDeskSubscription = this.desksTurnsService.addNewDesk(this.basicDataForm.get('active').value, this.imageUrl, this.basicDataForm.get('name').value, selectedCenter, selectedDeskType, voiceActivate, voicePrefix, deskPrefix, canAskCustomerName, dailyReset, smsNotify, selectedSms, notifyPrevious, notifyLast, canPrint, selectedTicket, countAutoReset, initialCount, limitCount, this.rememberedSchedules, showTurnsAtTotem, availableTurn, autoAdvance, dataType, hasVip).subscribe(
        (res) => {
          for (const schedule of this.desksTurnsService.getRememberedSchedules()) {
            this.addNewDeskSchedule(schedule, res['data']['internalId']);
          }
          this.showButton = true;
          this.spinnerService.hide('desk-new-spinner');
          this.router.navigate(['../../desks'], { relativeTo: this.activatedRoute });
        },
        (error) => {
          this.showButton = true;
          this.spinnerService.hide('desk-new-spinner');
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.showButton = true;
      this.spinnerService.hide('desk-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public cancelDesk() {
    this.router.navigate(['../../desks'], { relativeTo: this.activatedRoute });
  }

  public addNewDeskSchedule(schedule, relatedEntityInternalId) {
    this.addNewDeskScheduleSubscription = this.desksTurnsService.addNewDeskSchedule(relatedEntityInternalId, schedule.Mon, schedule.Tue, schedule.Wed, schedule.Thu, schedule.Fri, schedule.Sat, schedule.Sun, schedule.OpenTimeMorning, schedule.CloseTimeMorning, schedule.OpenTimeAfternoon, schedule.CloseTimeAfternoon, schedule.StartDate, schedule.EndDate, schedule.OpenService, schedule.CommentNote, schedule.TimeZone).subscribe(
      (res) => {
        this.snackbarService.open('desks-page.snackbar messages.add desk success', 'success');
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public validateForm() {
    if (!this.imageUrl) {
      return 'turns-page.snackbar messages.image desk error';
    } else if (!this.basicDataForm.get('name').valid) {
      return 'turns-page.snackbar messages.name desk error';
    } else if (!this.basicDataForm.get('selectedCenter').valid) {
      return 'turns-page.snackbar messages.selected center desk error';
    } else if (!this.basicDataForm.get('selectedDeskType').valid) {
      return 'turns-page.snackbar messages.selected type desk error';
    } else if (this.basicDataForm.get('countAutoReset').value && !this.basicDataForm.get('initialCount').value) {
      return 'turns-page.snackbar messages.initial count desk error';
    } else if (this.basicDataForm.get('countAutoReset').value && !this.basicDataForm.get('limitCount').value) {
      return 'turns-page.snackbar messages.limit count desk error';
    } else if (this.basicDataForm.get('smsNotify').value && !this.basicDataForm.get('selectedSMS').value) {
      return 'turns-page.snackbar messages.selected sms required desk error';
    } else if (this.basicDataForm.get('canPrint').value && !this.basicDataForm.get('selectedTicket').value) {
      return 'turns-page.snackbar messages.selected ticket required desk error';
    } else {
      return true;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  public setSelectedCenter(selectedCenterId) {
    if (selectedCenterId && this.centerList && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === selectedCenterId) {
          return center;
        }
      }
    } else {
      return null;
    }
  }

  public setSelectedDeskType(selectedDeskType) {
    if (selectedDeskType && this.centerList && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === selectedDeskType) {
          return center;
        }
      }
    } else {
      return null;
    }
  }

  public getSelectedCenter() {
    if (this.centerList.length === 1) {
      return this.centerList[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public getSelectedDeskType() {
    if (this.deskTypes.length === 1) {
      return this.deskTypes[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedDeskType').value) {
        return this.basicDataForm.get('selectedDeskType').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public getSelectedSMS() {
    if (this.smsList && this.smsList.length === 1) {
      return this.smsList[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedSMS').value) {
        return this.basicDataForm.get('selectedSMS').value.InternalId;
      } else {
        return false;
      }
    }
  }

  public getSelectedTicket() {
    if (this.ticketList && this.ticketList.length === 1) {
      return this.ticketList[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedTicket').value) {
        return this.basicDataForm.get('selectedTicket').value.InternalId;
      } else {
        return false;
      }
    }
  }

  public cleanResetAuto() {
    if (this.basicDataForm.get('countAutoReset').value) {
      this.basicDataForm.get('initialCount').disable();
      this.basicDataForm.get('limitCount').disable();
      this.basicDataForm.patchValue({
        initialCount: '',
        limitCount: ''
      });
    } else {
      this.basicDataForm.get('initialCount').enable();
      this.basicDataForm.get('limitCount').enable();
    }
  }

  public setDefaultVoiceActivateValue() {
    if (this.basicDataForm.get('selectedDeskType').value.InternalId === 'MSHMV2BJ9THXZL9CIYPT25T6R7427OY42') {
      this.basicDataForm.patchValue({
        voiceActivate: true
      });
    } else {
      this.basicDataForm.patchValue({
        voiceActivate: false
      });
    }
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.imageUrl = result[0].Url;
        }
      });
  }

  public addSchedule() {
    this.desksTurnsService.rememberDeskInfoFromSchedule();
    this.router.navigate(['schedule'], { relativeTo: this.activatedRoute });
  }

  public rememberDeskInfo() {
    this.desksTurnsService.rememberDeskInfo(this.imageUrl, this.basicDataForm);
  }

  public deleteRememberedSchedule(schedule) {
    this.desksTurnsService.deleteRememberedSchedule(schedule);
  }

  public gotoNewSms() {
    this.router.navigate(['turns/parameters/sms']);
  }

  public gotoNewTicket() {
    this.router.navigate(['turns/parameters/ticket']);
  }

  public centerSelectionChanged() {
    this.basicDataForm.get('selectedTicket').patchValue(null);
    this.getTicketListByCenters();
  }

  private getTicketListByCenters() {
    this.getTicketListByCentersSubscription = this.ticketsService.getTicketListByCenters([this.basicDataForm.get('selectedCenter').value.InternalId]).subscribe(
      (res) => {
        this.ticketList = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  ngOnDestroy() {
    if (this.rememberDeskInfoFromSheduleListenSubscription) { this.rememberDeskInfoFromSheduleListenSubscription.unsubscribe(); }
    if (this.addNewDeskSubscription) { this.addNewDeskSubscription.unsubscribe(); }
    if (this.addNewDeskScheduleSubscription) { this.addNewDeskScheduleSubscription.unsubscribe(); }
    if (this.getSmsListSubscription) { this.getSmsListSubscription.unsubscribe(); }
    if (this.getTicketListByCentersSubscription) { this.getTicketListByCentersSubscription.unsubscribe(); }
    if (this.validationImageToBase64Subscription) { this.validationImageToBase64Subscription.unsubscribe(); }
  }
}
